function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.586 5L5.293 1.707A1 1 0 016.707.293l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414-1.414L8.586 7H1a1 1 0 010-2h7.586z",
  fill: "#243143"
});

function SvgArrowRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNTg1NzkgNUw1LjI5Mjg5IDEuNzA3MTFDNC45MDIzNyAxLjMxNjU4IDQuOTAyMzcgMC42ODM0MTggNS4yOTI4OSAwLjI5Mjg5M0M1LjY4MzQyIC0wLjA5NzYzMTEgNi4zMTY1OCAtMC4wOTc2MzExIDYuNzA3MTEgMC4yOTI4OTNMMTEuNzA3MSA1LjI5Mjg5QzEyLjA5NzYgNS42ODM0MiAxMi4wOTc2IDYuMzE2NTggMTEuNzA3MSA2LjcwNzExTDYuNzA3MTEgMTEuNzA3MUM2LjMxNjU4IDEyLjA5NzYgNS42ODM0MiAxMi4wOTc2IDUuMjkyODkgMTEuNzA3MUM0LjkwMjM3IDExLjMxNjYgNC45MDIzNyAxMC42ODM0IDUuMjkyODkgMTAuMjkyOUw4LjU4NTc5IDdIMUMwLjQ0NzcxNSA3IDAgNi41NTIyOCAwIDZDMCA1LjQ0NzcyIDAuNDQ3NzE1IDUgMSA1SDguNTg1NzlaIiBmaWxsPSIjMjQzMTQzIi8+Cjwvc3ZnPg==";
export { SvgArrowRight16 as ReactComponent };